import React, { useEffect, useState } from "react"
import {
  listActualitesContainer,
  actualitesContainer,
  listActualitesTitle,
  actualitesDescription,
  editButtonTitle,
} from "./actualites.module.scss"
import { Title } from "./actualites-styled"
import ContentTransformer from "../../Transformers/content-transformer"
import RenderActualites from "./RenderActualites/render-actualites"
import { useActualites } from "./actualites-query"
import { getPublishedData } from "../../get-published-data"
import EditButton from "../../EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListActualites = () => {
  const data = useActualites()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodeActualites.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <div className={listActualitesContainer}>
      <Title className={listActualitesTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "À la une"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={actualitesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={actualitesContainer}>
        <RenderActualites actualiteData={finalData} />
      </div>
    </div>
  )
}

//-----------------------Parent component---------------------------//

export default ListActualites
